import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { QueryParameter } from '../../../base-models/query-parameter';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { BaseInput } from '../base-input';
import { NotificationService } from '../../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fw-text-area-modal',
  templateUrl: './text-area-modal.component.html'
})
export class TextAreaModalComponent extends BaseInput implements OnInit {

  // constructor(public activeModal: NgbActiveModal,
  //             protected notificationService: NotificationsService,
  //             protected changeDetectorRef: ChangeDetectorRef
  // ) { super(changeDetectorRef)}

  constructor(public activeModal: NgbActiveModal,
    protected toastrService: NotificationService,
    protected changeDetectorRef: ChangeDetectorRef
) { super(changeDetectorRef)}


  @Input() Parameters: QueryParameter[];
  MaxLength=500;
  Label;

  ngOnInit() {
    // this.formGroup.patchValue({Value: this.Parameters[0].Value})
    // this.MaxLength = Number(this.Parameters[1].Value);
    // this.Label = this.Parameters[2].Value
    this.value = this.Parameters[0].Value;
    this.MaxLength = Number(this.Parameters[1].Value);
    this.Label = this.Parameters[2].Value;
  }

  formGroup = new FormGroup({
    Value: new FormControl()
  })
  onKeyDown(event){
    if(event.keyCode == 13){
        event.stopPropagation();
    }
}

  Save(){
    this.activeModal.close(this.value)
  }

  Close(){
      this.activeModal.dismiss('Closed by user');
  }

}
